export const CREDIT_PACKAGES = {
  starter: {
    name: 'Starter',
    price: 29,
    credits: 2,
    priceId: process.env.STRIPE_STARTER_CREDITS_PRICE_ID,
  },
  pro: {
    name: 'Pro',
    price: 59,
    credits: 6,
    highlighted: true,
    priceId: process.env.STRIPE_PRO_CREDITS_PRICE_ID,
  },
  advanced: {
    name: 'Advanced',
    price: 99,
    credits: 12,
    priceId: process.env.STRIPE_ADVANCED_CREDITS_PRICE_ID,
  },
} as const;

export type PackageType = keyof typeof CREDIT_PACKAGES;

/**
 * Resolves a Stripe price ID to a credit package key.
 */
export function getPackageByPriceId(
  priceId: string
): PackageType | null {
  for (const [key, pkg] of Object.entries(CREDIT_PACKAGES)) {
    if (pkg.priceId === priceId) {
      return key as PackageType;
    }
  }
  return null;
}
